import { render, staticRenderFns } from "./GetErrorInfo.vue?vue&type=template&id=28b0e382&scoped=true&"
import script from "./GetErrorInfo.vue?vue&type=script&lang=js&"
export * from "./GetErrorInfo.vue?vue&type=script&lang=js&"
import style0 from "./GetErrorInfo.vue?vue&type=style&index=0&id=28b0e382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0e382",
  null
  
)

export default component.exports